import { render, staticRenderFns } from "./PageServeSingle.vue?vue&type=template&id=58c0f0aa&scoped=true&"
import script from "./PageServeSingle.vue?vue&type=script&lang=js&"
export * from "./PageServeSingle.vue?vue&type=script&lang=js&"
import style0 from "./PageServeSingle.vue?vue&type=style&index=0&id=58c0f0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c0f0aa",
  null
  
)

export default component.exports